module.exports = __webpack_public_path__ + "static/img/label_lineweight.c59d40bb.png";